import axios from "../utils/axios";

export const getTaskList = (payload) => {
    return axios.post(`/AutonomousMaintenance/GetTaskPage?PageSize=${payload.pageSize}&PageNumber=${payload.currentPage}`, payload.data);
};

export const getList = () => {
    return axios.get("/Pool/GetList");
};

export const getStatusList = () => {
    return axios.get("/AutonomousMaintenance/GetStatusList");
};

export const getUnplannedMaintenance = (data) => {
    return axios.get("UnplannedMaintenance/GetList?statusArr=" + data);
};

export const getAreaList = () => {
    return axios.get("/Area/GetList");
};

export const getTechnicianList = () => {
    return axios.get("/User/GetTechnicianList");
};

export const getMainListByAreaID = (areaID) => {
    return axios.get("/Equipment/GetMainListByAreaID?areaId=" + areaID);
};

export const getSubListById = (mainEquipmentID) => {
    return axios.get("/Equipment/GetSubListById?equipmentId=" + mainEquipmentID);
};
